import { render, staticRenderFns } from "./MaidClaimPost.vue?vue&type=template&id=1c658697&"
import script from "./MaidClaimPost.vue?vue&type=script&lang=js&"
export * from "./MaidClaimPost.vue?vue&type=script&lang=js&"
import style0 from "./MaidClaimPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidClaimPost.vue"
export default component.exports